// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3Z7-Y","title":"Info_title__2B6bV","links":"Info_links__dSU8Y","link":"Info_link__30a2q","logo":"Info_logo__3NB85"};